import { inject, Injectable } from '@angular/core';
import { ProjectApi } from '../../api/project.api';
import { Observable, of, switchMap, throwError } from 'rxjs';
import { BulkStats, Survey } from '@ps/survey-utils';
import { ApiStatusMessageResponse, Nullable } from '@ps/utils';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  private readonly _api = inject(ProjectApi);

  public getSurveyBulkStats(
    surveyIds: Array<number>,
  ): Observable<Nullable<BulkStats>> {
    if (!surveyIds.length) {
      return of(null);
    }
    return this._api.getSurveyBulkStats(surveyIds);
  }

  public getCombinedSummaryReport(
    email: string,
    selectedSurveys: Survey[],
  ): Observable<ApiStatusMessageResponse> {
    return this._api.getCombinedSummaryReport(email, selectedSurveys).pipe(
      switchMap((res) => {
        if (res.status !== 'Success') {
          return throwError(
            () =>
              new Error(
                res.message ?? 'Download Combined Summary Report Failed.',
              ),
          );
        }
        return of(res);
      }),
    );
  }
}
